/* eslint-disable no-loop-func */
//Table ant design

import { Badge, Button, Col, Form, Row } from 'react-bootstrap';
import React, { useCallback, useEffect, useState } from 'react';
import {
  dateToTimestamp,
  timestampToDateWithoutSecond,
} from '../../common/handleTimestamp';

import { Spin } from 'antd';
import { Table } from 'ant-table-extensions';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import telemetryController from '../../redux/api/tbTelemetryController';
import { useTranslation } from 'react-i18next';

const DiaryHistory = ({ deviceId, dataDiagram }) => {
  const token = localStorage.getItem('token');
  const { t } = useTranslation();

  const [datepicker, setDatepicker] = useState('');

  const [curPage, setCurPage] = useState(1);
  const [pagination, setPagination] = useState({
    current: curPage,
    pageSize: 10,
    total: 10,
    position: ['topLeft', 'none'],
  });
  const [loading, setLoading] = useState(false);

  const [dataOperation, setDataOperation] = useState([]);
  const [columnOperation, setColumnOperation] = useState([
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: t('time'),
      dataIndex: 'time',
      key: 'time',
      width: '150px',
    },
  ]);

  const fetchData = useCallback(async (startTs, endTs) => {
    setLoading(true);
    const dataOpr = await telemetryController.getTimeseries(
      token,
      deviceId,
      'operation',
      startTs,
      endTs,
      1500
    );

    // operation
    let rowDataExportOperation = [];
    let indexRowExportOperation = 0;
    const newDataDiagram = [
      ...dataDiagram,
      {
        type: 'alert',
        label: 'alert',
      },
    ];
    
    // create columns operation
    for (const idx in dataOpr.operation) {
      const time = dataOpr.operation[idx].ts;
      const obj = JSON.parse(dataOpr.operation[idx].value);
      let rowData = {
        key: idx,
        index: ++indexRowExportOperation,
        time: timestampToDateWithoutSecond(time),
      };
      newDataDiagram.forEach((itemData) => {
        const currentKey =
          (itemData.type === 'pt'
            ? 'pressure'
            : itemData.type === 'van' || itemData.type === 'vf'
            ? 'pump'
            : itemData.type === 'light'
            ? 'float'
            : itemData.type) + itemData.number;
        const item = columnOperation.filter((item) => item.key === currentKey);

        if (item.length === 0) {
          const name = itemData.label;
          const title = name ? name : item.title;
          columnOperation.push({
            title: t(title).toLocaleUpperCase(),
            dataIndex: currentKey,
            key: currentKey,
            render: (value) => {
              if (currentKey.includes('alert')) {
                return value === true ? (
                  <Badge pill bg="danger" text="light">
                    {t('over-threshold')}
                  </Badge>
                ) : (
                  <Badge pill bg="secondary" text="light">
                    {t('normal')}
                  </Badge>
                );
              }
              if (currentKey.includes('float')) {
                if (/^float[5-8]$/.test(currentKey)) {
                  return value;
                } else {
                  return value === t('full') ? (
                    <Badge pill bg="success" text="light">
                      {t('full')}
                    </Badge>
                  ) : (
                    <Badge pill bg="danger" text="light">
                      {t('empty')}
                    </Badge>
                  );
                }
              }
              return value === t('on') ? (
                <Badge pill bg="success" text="light">
                  {currentKey.includes('mode') ? t('auto') : t('on')}
                </Badge>
              ) : value === false ? (
                <Badge pill bg="secondary" text="light">
                  {currentKey.includes('mode') ? t('manual') : t('off')}
                </Badge>
              ) : (
                value
              );
            },
          });
        }
        if (currentKey.includes('alert')) {

          rowData[currentKey] = obj[currentKey]; // === true ? t('over-threshold') : t('normal');
        } else if (currentKey.includes('float')) {
          if (/^float[5-8]$/.test(currentKey)) {
            rowData[currentKey] = obj[currentKey] === true ? t('on') : t('off');
          } else {
            rowData[currentKey] =
              obj[currentKey] === true ? t('full') : t('empty');
          }
        } else if (currentKey.includes('mode')) {
          rowData[currentKey] =
            obj[currentKey] === true ? t('auto') : t('manual');
        } else {
          rowData[currentKey] =
            obj[currentKey] === true
              ? t('on')
              : obj[currentKey] === false
              ? t('off')
              : obj[currentKey];
        }
      });
      rowDataExportOperation.push(rowData);
    }
    setDataOperation(rowDataExportOperation);
    setPagination({ ...pagination, total: indexRowExportOperation });
    setLoading(false);
  }, []);

  const handleGetData = (datepick) => {
    setDatepicker(datepick);
    if (deviceId && datepick) {
      const startTs = dateToTimestamp(datepick + ' 00:00:00');
      const endTs = dateToTimestamp(datepick + ' 23:59:59');
      fetchData(startTs, endTs);
    }
  };

  const handleUpdateTable = () => {
    if (deviceId && datepicker) {
      const startTs = dateToTimestamp(datepicker + ' 00:00:00');
      const endTs = dateToTimestamp(datepicker + ' 23:59:59');
      fetchData(startTs, endTs);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (curPage !== pagination.current) {
      setCurPage(pagination.current);
    }
    setPagination(pagination);
  };
  const [tableContent, setTableContent] = useState();

  useEffect(() => {
    let html;
    if (loading) html = <Spin />;
    else if (dataOperation.length > 0) {
      html = (
        <Table
          columns={columnOperation}
          dataSource={dataOperation}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ x: '1600px', y: '45vh' }}
        />
      );
    } else {
      html = <Table />;
    }
    setTableContent(html);
  }, [columnOperation, dataOperation, pagination, loading]);

  const ExportCSV = ({ dataRow, dataCol, fileName }) => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (dataRow, dataCol, fileName) => {
      var fields = dataCol?.map((e) => e.key);

      const columnHeader = dataCol?.map((e) => e.title);

      const workBook = new Workbook();
      const workSheet = workBook.addWorksheet(t('activity-log'));
      workSheet.addRow(columnHeader);

      dataRow.map((e) => {
        const row = workSheet.addRow(
          fields.map((fieldName) => {
            return fieldName !== 'alert'
              ? e[fieldName]
              : e.alert
              ? t('over-threshold')
              : t('normal');
          })
        );
        for (let i = 1; i <= fields.length; i++) {
          const col = row.getCell(i);

          col.fill = e.alert
            ? {
                type: 'pattern',
                pattern: 'solid',

                fgColor: { argb: 'FF0000' },
              }
            : '';
        }
      });
      workBook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type: fileType,
        });
        saveAs(blob, fileName + fileExtension);
      });
    };

    return (
      <Button
        id="exportOperation"
        variant="primary"
        onClick={(e) => exportToCSV(dataRow, dataCol, fileName)}
      >
        + {t('export-excel')}
      </Button>
    );
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Label>{t('pick-date')}</Form.Label>
          <Form.Control
            type="date"
            id="datepicker"
            onChange={(e) => handleGetData(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ marginTop: '12px' }}>
            {dataOperation && dataOperation.length > 0 ? (
              <ExportCSV
                dataRow={dataOperation}
                dataCol={columnOperation}
                fileName={`Operation[` + datepicker + ']'}
              />
            ) : (
              <Button id="exportOperation" variant="primary" disabled>
                + {t('export-excel')}
              </Button>
            )}
            <Button
              id="updateDeviceBtn"
              variant="primary"
              onClick={handleUpdateTable}
            >
              {t('update')}
            </Button>
          </div>
        </Col>
      </Row>

      <div className="spinner-grow" role="status" id="spinner" hidden></div>
      {tableContent}
    </>
  );
};

export default DiaryHistory;
